const {CardDeck, MilitaryCardTypes}  = require("../../Constants/Constants");
const Card = require("./Card");

class WarCard extends Card{
    constructor(war)
    {
        super(
            CardDeck.Military,
            MilitaryCardTypes.War,
            null,
            war.GetName(),
            war.GetAge(),
            war.GetText(),
            war.GetEffects(),
        )
        this.war = war;
    }
}

module.exports = WarCard;